import {createAction, props} from "@ngrx/store";
import {FlowMetaData} from '../../../shared/models/flow-meta-data';

import {FlowModeState} from "../../../shared/models/state/Flow";
import {NodeObject} from "../../../shared/utils/nodeTypes";

/* Creating an action that will be dispatched to the store. */
export const flowModeAction = createAction(
    '[Flow State Mode] Toggle Between States',
    props<{ flowModeState: FlowModeState }>()
);

export const flowMetaDataAction = createAction(
    '[Flow] Update FlowMetaData',
    props<{ flowMetaData: FlowMetaData }>()
);
export const loadChatHubProviders = createAction(
    '[Flow chatHub] Get chat hub providers'
);

export const setChatHubProvidersAction = createAction(
    '[Flow chatHub] Set chat hub providers',
    props<{ chatHubProviders: NodeObject[] }>()
);

export const addNodeType = createAction(
    '[Flow] Adding a node type',
    props<{ nodeObject: NodeObject, nodeName: string }>()
);

export const resetNodeType = createAction(
    '[Flow] Resetting node type',
);

export const setPermissions = createAction(
    '[Flow permission] Set permissions',
    props<{ permissions: any }>()
)